<template>
  <v-card elevation="2" style="padding: 5em">
    <v-row>
      <v-card class="mx-auto" max-width="400">
        <v-card-title>
          <v-icon large left> mdi-cloud-upload-outline </v-icon>
          <span class="text-h6 font-weight-light">CV Uploadé</span>
        </v-card-title>

        <v-card-text
          class="text-h5 font-weight-bold"
          v-if="currentCvFilePath !== false"
        >
          Vous pouvez télécharger votre dernier CV uploadé le
          {{ new Date(this.seeker?.cv.updatedAt).toLocaleString("fr-FR") }}
        </v-card-text>
        <v-card-text
          class="text-h5 font-weight-bold"
          v-if="currentCvFilePath === false"
        >
          Vous n'avez mis en ligne aucun cv pour le moment
        </v-card-text>

        <v-card-actions v-if="currentCvFilePath !== false">
          <v-list-item class="grow">
            <v-row align="center" justify="end">
              <v-icon class="mr-1"> mdi-monitor-arrow-down-variant </v-icon>
              <span class="subheading mr-2">
                <a target="_blank" :href="currentCvFilePath"> Télécharger </a>
              </span>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
      <v-card class="mx-auto" max-width="400">
        <v-card-title>
          <v-icon large left> mdi-cloud-upload-outline </v-icon>
          <span class="text-h6 font-weight-light"
            >Publier mon Cv dans la cvtèque</span
          >
        </v-card-title>

        <v-card-text class="text-h5 font-weight-bold">
          <UploadCvInCvteque />
        </v-card-text>
      </v-card>
      <v-card class="mx-auto" color="#022A67" dark max-width="400">
        <v-card-title>
          <v-icon large left> mdi-file-document-multiple-outline </v-icon>
          <span class="text-h6 font-weight-light">CV Généré</span>
        </v-card-title>

        <v-card-text
          class="text-h5 font-weight-bold text--white"
          v-if="currentGeneratedTemplate !== false"
        >
          Vous pouvez télécharger votre dernier CV généré sur notre plateforme
        </v-card-text>
        <v-card-text
          class="text-h5 font-weight-bold text--white"
          v-if="currentGeneratedTemplate === false"
        >
          Vous n'avez généré aucun CV sur notre plateforme
        </v-card-text>

        <v-card-actions v-if="currentGeneratedTemplate !== false">
          <v-list-item class="grow">
            <v-row align="center" justify="end">
              <v-icon class="mr-1"> mdi-monitor-arrow-down-variant </v-icon>
              <span class="subheading mr-2">
                <a target="_blank" :href="currentGeneratedTemplateLink">
                  Télécharger
                </a>
              </span>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
    </v-row>
  </v-card>
</template>

<script>
import HttpClient from "@/services/HttpClient/HttpClient";
import UploadCvInCvteque from "@/components/Candidate/UploadCvInCvteque.vue";

export default {
  name: "CurrentResumes",
  components: { UploadCvInCvteque },
  data: () => ({
    seeker: null,
    currentCvFilePath: null,
    currentGeneratedTemplate: null,
    currentGeneratedTemplateLink: null,
  }),
  methods: {
    fetchCurrentSeeker() {
      const httpClient = new HttpClient();
      httpClient
        .getCurrentSeeker(localStorage.getItem("jwt-token"))
        .then((res) => {
          this.seeker = res.data;
          if (this.seeker.cv)
            this.currentCvFilePath = `${process.env.VUE_APP_JOB_BOARD_API_ENDPOINT}/uploads/cv/${this.seeker.cv.fileName}`;
          else this.currentCvFilePath = false;

          if (res.data.defaultCvTemplate) {
            this.currentGeneratedTemplate = res.data.defaultCvTemplate;
            const currentUser = JSON.parse(localStorage.getItem("currentUser"));
            this.currentGeneratedTemplateLink = `${process.env.VUE_APP_JOB_BOARD_API_ENDPOINT}/download/resume/${this.currentGeneratedTemplate.id}/${currentUser.id}`;
            console.log(this.currentGeneratedTemplateLink);
          } else {
            this.currentGeneratedTemplate = false;
          }
          console.log(this.currentCvFilePath);
          console.log(this.seeker);
        });
    },
  },
  created() {
    this.fetchCurrentSeeker();
  },
};
</script>

<style scoped></style>
